<template>
  <div id="QuarantineTransfer">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="header d-flex justify-space-between pr-5 align-center">
        <h1>Quarentena de Transferência</h1>
      </div>
      <div class="mt15"></div>
      <quarantine-filters :loadingGetAll="loadingFilter" :isTransfer="true" @filterSearch="filterSearch" />

      <v-tabs class="px-8 py-4">
        <v-tab>Hierarquia</v-tab>
        <v-tab>Gerenciamento Rápido</v-tab>

        <v-tab-item>
          <div class="table p-relative">
            <table-title-row :columnsOptions="columnsOptions"></table-title-row>
            <v-progress-linear v-if="isTransferLoading" indeterminate color="primary"></v-progress-linear>
            <template v-if="nodes.length">
              <template v-for="(node, nodeIndex) in nodes">
                <div :key="node.data.id">
                  <table-body-row
                    :node="node"
                    :nodeIndex="nodeIndex"
                    :columns="columns"
                    :itemsDropdown="itemsDropdown"
                    :lengthDataToTruncate="14"
                    :type="'Parada'"
                    :enableCheckbox="true"
                    :enableDropdown="true"
                    :selectedCheckbox="selectedCheckbox"
                    @onExpand="onExpand(node)"
                    @actionsDropdown="actionsDropdown"
                    @changeCheckbox="changeSelectedCheckbox"
                  >
                  </table-body-row>

                  <v-row v-if="node.open" style="margin-top: 0">
                    <v-col cols="12">
                      <v-card :loading="loading">
                        <v-card-text class="p-5">
                          <table-title-row :columnsOptions="columnsDeliveriesOptions"></table-title-row>

                          <template v-for="(deliveries, deliveriesIndex) in node.children">
                            <div :key="deliveries.data.id">
                              <table-body-row
                                :node="deliveries"
                                :nodeIndex="deliveriesIndex"
                                :columns="columnsDeliveries"
                                :itemsDropdown="itemsDropdown"
                                :lengthDataToTruncate="12"
                                :type="'Entrega'"
                                :stopIndex="nodeIndex"
                                :enableCheckbox="true"
                                :enableDropdown="true"
                                @onExpand="onExpand(deliveries)"
                                @actionsDropdown="actionsDropdown"
                                @changeCheckbox="changeSelectedCheckbox"
                              >
                              </table-body-row>

                              <v-row v-if="deliveries.open" style="margin-top: 0">
                                <v-col cols="12">
                                  <v-card :loading="loading">
                                    <v-card-text class="p-5">
                                      <table-title-row :columnsOptions="columnsNfeOptions"></table-title-row>

                                      <template v-for="(nfe, nfeIndex) in deliveries.children">
                                        <div :key="nfe.data.id">
                                          <table-body-row
                                            :node="nfe"
                                            :nodeIndex="nfeIndex"
                                            :columns="columnsNfe"
                                            :itemsDropdown="itemsDropdownNfe"
                                            :lengthDataToTruncate="13"
                                            :type="'Nota Fiscal'"
                                            :enableCheckbox="true"
                                            :enableDropdown="true"
                                            :stopIndex="nodeIndex"
                                            :deliveryIndex="deliveriesIndex"
                                            @onExpand="onExpand(nfe)"
                                            @actionsDropdown="actionsDropdownNfe"
                                            @changeCheckbox="changeSelectedCheckbox"
                                          >
                                          </table-body-row>
                                        </div>
                                      </template>
                                    </v-card-text>
                                  </v-card>
                                  <div class="mt20"></div>
                                </v-col>
                              </v-row>
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                      <div class="mt20"></div>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center pt-6 pb-2" style="color: grey">Nenhum registro encontrado.</div>
            </template>
            <div class="mt50"></div>
            <div class="d-flex justify-space-between">
              <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
              <v-btn elevation="2" color="info" @click="openStatus"> ATUALIZAR STATUS </v-btn>
            </div>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="table p-relative">
            <table-title-row :columnsOptions="columnsOptions"></table-title-row>
            <v-progress-linear v-if="isTransferFastLoading" indeterminate color="primary"></v-progress-linear>
            <template v-if="nodesFast.length">
              <template v-for="(node, nodeIndex) in nodesFast">
                <div :key="node.data.id">
                  <table-body-row
                    :node="node"
                    :nodeIndex="nodeIndex"
                    :columns="columns"
                    :itemsDropdown="itemsDropdown"
                    :lengthDataToTruncate="13"
                    :type="'Parada'"
                    :enableCheckbox="true"
                    :enableDropdown="true"
                    @onExpand="onExpandFast(node)"
                    @actionsDropdown="actionsDropdown"
                    @changeCheckbox="changeSelectedCheckbox"
                  >
                  </table-body-row>
                  <v-progress-linear
                    v-if="nfeLoading && nodeIndex === currentNfeLoading"
                    indeterminate
                    color="primary"
                  ></v-progress-linear>

                  <v-row v-if="node.open" class="px-2" style="margin-top: 0">
                    <v-col cols="12">
                      <v-card>
                        <v-card-text class="p-5">
                          <table-title-row :columnsOptions="columnsNfeOptions"></table-title-row>

                          <template v-for="(nfe, nfeIndex) in node.children">
                            <div :key="nfe.data.id">
                              <table-body-row
                                :node="nfe"
                                :nodeIndex="nfeIndex"
                                :columns="columnsNfe"
                                :itemsDropdown="itemsDropdownNfe"
                                :lengthDataToTruncate="13"
                                :type="'Nota Fiscal'"
                                :enableCheckbox="true"
                                :enableDropdown="true"
                                :stopIndex="nodeIndex"
                                @onExpand="onExpand(nfe)"
                                @actionsDropdown="actionsDropdownNfe"
                                @changeCheckbox="changeSelectedCheckboxFast"
                              >
                              </table-body-row>
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                      <div class="mt20"></div>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center pt-6 pb-2" style="color: grey">Nenhum registro encontrado.</div>
            </template>
            <div class="mt50"></div>
            <div class="d-flex justify-space-between">
              <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
              <v-btn elevation="2" color="info" @click="openStatus"> ATUALIZAR STATUS </v-btn>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <UpdateStatusNfe
      :selectedCheckbox="selectedCheckbox"
      :nfeSelected="nfeSelected"
      :open="updateStatus"
      role="TransferQuarantine"
      @closeUpdateStatusNfe="closeUpdateStatusNfe"
    />

    <UpdateNumber :open="updateNumber" :nfeSelectedId="nfeSelectedId" @closeUpdateNumber="updateNumber = false" />

    <HistoricNfe :id="nfeSelectedId" :open="historic" @closeHistoricNfe="historic = false" />

    <Canhoto :id="nfeSelectedId" :open="canhoto" @closeCanhoto="canhoto = false" />

    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import MessagesError from '../../../components/MessagesError.vue';

import TableTitleRow from '../../../components/Table/Table-Title-Row.vue';
import TableBodyRow from '../../../components/Table/Table-Body-Row.vue';

import maskCPF from '../../../utils/maskCPF';
import maskCNPJ from '../../../utils/maskCNPJ';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
import maskWeight from '../../../utils/maskWeight';
import changeCheckbox from '../../../utils/changeSelectedCheckbox';

import HistoricNfe from '../../../components/Nfe/HistoricNfe.vue';
// import UpdateStatusQuarantine from "../../../components/Quarantine/UpdateStatusQuarantine.vue";
import UpdateStatusNfe from '../../../components/Nfe/UpdateStatusNfe.vue';
import UpdateNumber from '../../../components/Quarantine/UpdateNumber.vue';
import Canhoto from '../../../components/Quarantine/Canhoto.vue';
import QuarantineFilters from '../../../components/Quarantine/QuarantineFilters.vue';

export default {
  name: 'Quarantine',
  components: {
    BreadCrumb,
    MessagesError,
    HistoricNfe,
    TableTitleRow,
    TableBodyRow,
    // UpdateStatusQuarantine,
    UpdateNumber,
    Canhoto,
    UpdateStatusNfe,
    QuarantineFilters
  },
  data: () => ({
    isTransferLoading: false,
    isTransferFastLoading: false,
    nfeLoading: false,
    currentNfeLoading: null,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Quarentena',
        disabled: false,
        to: '/quarantine'
      },
      {
        text: 'Transferência',
        disabled: true,
        to: '/quarantine-transfer'
      }
    ],
    columns: ['type', 'recipientName', 'cityName', 'weight', 'price', 'actions'],
    columnsOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'recipientName',
        text: 'Destinatário'
      },
      {
        value: 'cityName',
        text: 'Cidade'
      },
      {
        value: 'weight',
        text: 'Peso'
      },
      {
        value: 'price',
        text: 'Preço'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsDeliveries: ['type', 'number', 'deliveryForecast', 'senderName', 'weight', 'actions'],
    columnsDeliveriesOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'number',
        text: 'Número CTE'
      },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      },
      {
        value: 'senderName',
        text: 'Enviado por'
      },
      {
        value: 'weight',
        text: 'Peso'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsNfe: ['type', 'justificationQuarantine', 'number', 'price', 'weight', 'completionDate', 'actions'],
    columnsNfeOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'justificationQuarantine',
        text: 'Justificativa'
      },
      { value: 'number', text: 'Número NFE' },
      { value: 'price', text: 'Preço da NF' },
      { value: 'weight', text: 'Peso da NF' },
      { value: 'completionDate', text: 'Data de Conclusão' },
      { value: 'actions', text: 'Ações' }
    ],
    errors: [],
    errorsType: null,
    loading: false,
    loadingFilter: false,
    nodes: [],
    nodesFast: [],
    selectedCheckbox: [],
    itemsDropdownNfe: [{ title: 'Histórico' }, { title: 'Visualizar Canhoto' }, { title: 'Atualizar nº chamado' }],
    itemsDropdown: [{ title: 'Atualizar Status' }],
    updateStatus: false,
    updateNumber: false,
    historic: false,
    canhoto: false,
    nfeSelected: [],
    nfeSelectedId: null,
    initialNode: 'Parada'
  }),
  computed: {
    ...mapState('QuarantineStore', ['paginate']),
    ...mapGetters('QuarantineStore', ['getStops']),
    ...mapGetters('NfeStore', ['getNfeByStatus']),
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllStops();
      }
    },
    getColumns() {
      const newColumns = this.columns.map((item) => {
        const newItem = this.columnOptions.filter((option) => {
          return option.value === item;
        });

        return newItem[0];
      });
      return newColumns;
    }
  },

  methods: {
    ...mapActions('QuarantineStore', [
      'fetchStopsByID',
      'fetchDeliveriesByID',
      'fetchNfesByID',
      'getNfesByStopAndStatusesIds'
    ]),
    ...mapActions('NfeStore', ['getNfesByStatusIdForManagement']),
    ...mapMutations('QuarantineStore', ['setItemPerPage', 'setPageNumber']),
    changeSelectedCheckbox(item, children, shipmentIndex, cargoIndex, stopIndex, deliveriesIndex) {
      this.selectedCheckbox = changeCheckbox(
        this.selectedCheckbox,
        item,
        children,
        cargoIndex,
        stopIndex,
        deliveriesIndex,
        this.nodes[stopIndex]
      );
    },
    changeSelectedCheckboxFast(item, children, shipmentIndex, cargoIndex, stopIndex, deliveriesIndex) {
      this.selectedCheckbox = changeCheckbox(
        this.selectedCheckbox,
        item,
        children,
        cargoIndex,
        stopIndex,
        deliveriesIndex,
        this.nodesFast[stopIndex]
      );
    },
    closeUpdateStatusNfe(hasChange, message) {
      this.updateStatus = false;
      this.nfeSelected = [];
      if (hasChange) {
        this.fetchAllStops();
        this.fetchAllNfe();
      }
      if (message) {
        console.log(message);
        this.errors = message.errors;
        this.errorsType = message.errorsType;
      }
    },
    closeUpdateNumber(message) {
      this.nfeSelected = [];
      this.updateNumber = false;
      if (message) {
        console.log(message);
        this.errors = message.errors;
        this.errorsType = message.errorsType;
      }
    },
    async filterSearch() {
      this.loadingFilter = true;
     await this.setPageNumber(1);
     await this.fetchAllStops();
     await this.fetchAllNfe();
      this.loadingFilter = false;
    },
    openStatus() {
      if (this.selectedCheckbox.length === 0) {
        this.errors = ['Nenhum item selecionado.'];
        this.errorsType = 'info';
      } else {
        this.updateStatus = true;
      }
    },
    transformWeight(weight) {
      return maskWeight(weight);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    transformDate(date) {
      return maskData(date);
    },
    actionsDropdown(index, node) {
      this.nfeSelected.push(node.data);
      if (index === 0) {
        this.updateStatus = true;
      }
    },
    actionsDropdownNfe(index, node) {
      this.nfeSelected.push(node.data);
      this.nfeSelectedId = node.data.id;
      if (index === 0) {
        this.historic = true;
      } else if (index === 1) {
        this.canhoto = true;
      } else if (index === 2) {
        this.updateNumber = true;
      }
    },
    async fetchAllNfe() {
      this.isTransferFastLoading = true;
      try {
        await this.getNfesByStatusIdForManagement('5');

        const newStops = this.getStops.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              price: this.transformPrice(item.price),
              cityName: item['address']['cityName'],
              type: 'Parada',
              actions: ''
            },
            children: [],
            type: 'Stops',
            open: false,
            selected: false
          };
        });

        this.nodesFast = newStops;
      } catch (err) {
        console.error(err);
      } finally {
        this.isTransferFastLoading = false;

        setTimeout(() => {
          this.viewCheckbox = true;
          this.selectedCheckbox = [];
        }, 0);
      }
    },
    async fetchAllStops() {
      this.isTransferLoading = true;
      try {
        await this.fetchStopsByID('5');

        const newStops = this.getStops.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              price: this.transformPrice(item.price),
              cityName: item['address']['cityName'],
              type: 'Parada',
              actions: ''
            },
            children: [],
            type: 'Stops',
            open: false,
            selected: false
          };
        });

        this.nodes = newStops;
      } catch (err) {
        console.error(err);
      } finally {
        this.fetchAllNfe();
        this.isTransferLoading = false;

        setTimeout(() => {
          this.viewCheckbox = true;
          this.selectedCheckbox = [];
        }, 0);
      }
    },
    async onExpand(selected) {
      this.loading = true;
      if (selected.type === 'Deliveries') {
        const idStop = Number(selected.key.split('-')[0]);
        const idDelivieres = Number(selected.key.split('-')[1]);

        this.nodes[idStop].children[idDelivieres].open = !this.nodes[idStop].children[idDelivieres].open;
        try {
          var modelNfe = {
            id: selected.data.id,
            status: 5
          };

          const nfes = await this.fetchNfesByID(modelNfe);

          const Nfes = nfes.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                type: 'Nota Fiscal',
                completionDate: this.transformDate(item.completionDate),
                price: this.transformPrice(item.price)
              },
              type: 'Nfes',
              open: false,
              selected: false
            };
          });

          if (this.nodes[idStop].children[idDelivieres].children.length === 0) {
            this.nodes[idStop].children[idDelivieres].children = Nfes;
          }

          if (selected.selected) {
            const selectedIds = this.selectedCheckbox.map((item) => item.id);
            this.nodes[idStop].children[idDelivieres].children.map((nfe) => {
              nfe.selected = true;
              if (!selectedIds.includes(nfe.data.id)) {
                this.selectedCheckbox.push(nfe.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
      if (selected.type === 'Stops') {
        const idStop = Number(selected.key);

        this.nodes[idStop].open = !this.nodes[idStop].open;
        try {
          var model = {
            id: selected.data.id,
            status: 5
          };
          const stops = await this.fetchDeliveriesByID(model);

          const newDeliveries = stops.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                deliveryForecast: this.transformDate(item.deliveryForecast),
                type: 'Entrega'
              },
              children: [],
              type: 'Deliveries',
              open: false,
              selected: false
            };
          });
          if (this.nodes[idStop].children.length === 0) {
            this.nodes[idStop].children = newDeliveries;
          }

          if (selected.selected) {
            const selectedIds = this.selectedCheckbox.map((item) => item.id);
            this.nodes[idStop].children.map((delivery) => {
              delivery.selected = true;
              if (!selectedIds.includes(delivery.data.id)) {
                this.selectedCheckbox.push(delivery.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
    },
    async onExpandFast(node) {
      const { key, open } = node;

      this.nodesFast[key].open = !this.nodesFast[key].open;

      if (open) {
        return;
      }

      this.nfeLoading = true;
      this.currentNfeLoading = key;

      var model = {
        stopId: node.data.id,
        status: 5
      };

      try {
        const data = await this.getNfesByStopAndStatusesIds(model);

        const nfes = data.map((item, index) => {
          return {
            key: node.key + '-' + index,
            data: {
              ...item,
              type: 'Nota Fiscal',
              price: this.transformPrice(item.price),
              completionDate: this.transformDate(item.completionDate)
            },
            type: 'QuickNfe',
            open: false,
            selected: false
          };
        });

        this.nodesFast[key].children = nfes;

        if (node.selected) {
          const selectedIds = this.selectedCheckbox.map((item) => item.id);
          this.nodesFast[key].children.map((nfe) => {
            nfe.selected = true;
            if (!selectedIds.includes(nfe.data.id)) {
              this.selectedCheckbox.push(nfe.data);
            }
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.nfeLoading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.p-treetable {
  max-width: 100%;
  overflow: auto;
}

.w-100-all {
  width: 100%;

  table {
    width: 100%;
    text-align: left;

    tr {
      padding: 0 15px;
    }
  }
}

.image-container {
  width: 100% !important;
}

.text-align-left {
  text-align: left;
}

.text-table-title {
  text-align: center;
  justify-content: center;
}
</style>
